module.exports = ".errorMessage {\n  color: red;\n  font-size: 11px; }\n\n.padding {\n  padding: 10px 0 !important; }\n\n.subFormField {\n  width: 77%; }\n"